import SpinnerIcon from '@pelckmans/elementis/icons/spinner';
import { useTranslation } from 'react-i18next';

export function ExerciseCalculating() {
  const { t } = useTranslation();
  return (
    <div className="exercise-container" data-testid="exercise-calculating">
      <div className="content">
        <SpinnerIcon data-testid="spinner" className="loading-icon" size="xl" />
        <div className="body">
          <h1 className="title">{t('EXERCISE_MANAGER.EXERCISE_CALCULATING.TITLE')}</h1>
          <div>
            <p>{t('EXERCISE_MANAGER.EXERCISE_CALCULATING.P1')}</p>
            <p>{t('EXERCISE_MANAGER.EXERCISE_CALCULATING.P2')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
